import { apiClient } from './api'

export interface ProjectOrgResponse {
  id: number
  project_id: number
  org_structure: {
    sponsor?: { name?: string; title?: string }
    projectManager?: { name?: string; title?: string }
    teams?: Array<{ manager: string; members: Array<{ name: string; role: string }> }>
  } | null
  created_at: string | null
  updated_at: string | null
}

export const projectOrgService = {
  get(projectId: number): Promise<ProjectOrgResponse> {
    return apiClient.get(`/api/v1/projects/${projectId}/org/`).then((r) => r.data)
  },
  update(projectId: number, org_structure: ProjectOrgResponse['org_structure']): Promise<ProjectOrgResponse> {
    return apiClient.patch(`/api/v1/projects/${projectId}/org/`, { org_structure }).then((r) => r.data)
  },
}
